export interface OperatorTrackingConfig {
    googleTag?: string
    facebookPixel?: string
}
/*ACME Pre-release:G-PR32QC9R3M*/
export const operatorsTracking: Record<string, OperatorTrackingConfig> = {
    "acme": {
        googleTag: "G-FD66FFXLVF",
    },
    "mshikebet-ke": {
        googleTag: "AW-17828510979",
    },
    "hallabet-ng": {
        googleTag: "GTM-5JZSLR3K",
    },
}